/* ==========================================================================
   ZAIB QUIZ JS
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  /* ==========================================================================
     ELEMENTS
     ========================================================================== */

  const steps = Array.from(document.querySelectorAll(".zaib_quiz_step"));
  const continueBtn = document.querySelector(".zaib_quiz_continue");
  const prevBtn = document.querySelector(".zaib_quiz_prev");
  const progressBar = document.querySelector(".zaib_quiz_progress_bar");
  const progressFill = document.querySelector(".zaib_quiz_progress_fill");
  const currentStepText = document.querySelector(".zaib_current_step");

  /* ==========================================================================
     QUIZ SETTINGS
     ========================================================================== */

  let currentStep = 1;

  const totalQuizScreens = 8;
  const loadingStep = totalQuizScreens + 1;
  const resultStep = totalQuizScreens + 2;

  /*
    Auto reset step numbers based on rendered snippets.

    Your final order:
    1. zaib-quiz-step-1
    2. zaib-quiz-step-3
    3. zaib-quiz-step-4
    4. zaib-quiz-step-5
    5. zaib-quiz-step-6
    6. zaib-quiz-step-7
    7. zaib-quiz-step-8
    8. zaib-quiz-step-10
    9. zaib-quiz-loading
    10. zaib-quiz-result
  */

  steps.forEach((stepItem, index) => {
    stepItem.dataset.step = String(index + 1);
  });

  /* ==========================================================================
     QUIZ STATE
     ========================================================================== */

const zaibQuizData = {
  dog_name: "",
  dog_count: "",
  age: "",
  weight: "",
  dog_size: "",
  dog_breed: "",
  body_type: "",
  activity: "",
  support_areas: [],
  changes: [],
  supplements: [],
  email: ""
};

  /* ==========================================================================
     RESULT PAGE DYNAMIC DATA
     ========================================================================== */

  const zaibResultPlanData = {
    mini: {
      label: "Mini",
      chews: "1 chew / morning",
      jar: "Mini • 4-month supply"
    },
    small: {
      label: "Small",
      chews: "2 chews / morning",
      jar: "Small • 2-month supply"
    },
    medium: {
      label: "Medium",
      chews: "3 chews / morning",
      jar: "Medium • 40-day supply"
    },
    large: {
      label: "Large",
      chews: "4 chews / morning",
      jar: "Large • 30-day supply"
    }
  };

  const zaibPlanData = {
    mini: {
      plan: "691241255201",
      dog: "Mini",
      weight: "Less than 25 lbs",
      chews: "1"
    },
    small: {
      plan: "691241287969",
      dog: "Small",
      weight: "25–50 lbs",
      chews: "2"
    },
    medium: {
      plan: "691241320737",
      dog: "Medium",
      weight: "50–75 lbs",
      chews: "3"
    },
    large: {
      plan: "691241353505",
      dog: "Large",
      weight: "75+ lbs",
      chews: "4"
    }
  };

  /* ==========================================================================
     INIT
     ========================================================================== */

  showStep(currentStep);
  updateProgress();
  updateButtons();

  /* ==========================================================================
     SHOW STEP
     ========================================================================== */

  function showStep(step) {
    steps.forEach((stepItem) => {
      stepItem.classList.remove("zaib_active");
    });

    const activeStep = document.querySelector(`.zaib_quiz_step[data-step="${step}"]`);

    if (activeStep) {
      activeStep.classList.add("zaib_active");
    }
  }

  /* ==========================================================================
     GET ACTIVE STEP
     ========================================================================== */

  function getActiveStep() {
    return document.querySelector(`.zaib_quiz_step[data-step="${currentStep}"]`);
  }

  /* ==========================================================================
     PROGRESS
     ========================================================================== */

  function updateProgress() {
    const isQuizScreen = currentStep <= totalQuizScreens;

    /*
      Loading and result are not part of progress.
      So progress bar is hidden on loading/result.
    */

    if (progressBar) {
      progressBar.style.display = isQuizScreen ? "" : "none";
    }

    if (!isQuizScreen) return;

    let progressStep = currentStep;

    if (progressStep < 1) progressStep = 1;
    if (progressStep > totalQuizScreens) progressStep = totalQuizScreens;

    const percent = (progressStep / totalQuizScreens) * 100;

    if (progressFill) {
      progressFill.style.width = `${percent}%`;
    }

    if (currentStepText) {
      currentStepText.textContent = progressStep;
    }
  }

  /* ==========================================================================
     BUTTONS
     ========================================================================== */

  function updateButtons() {
    if (!continueBtn || !prevBtn) return;

    if (currentStep > totalQuizScreens) {
      continueBtn.style.display = "none";
      prevBtn.style.display = "none";
      return;
    }

    continueBtn.style.display = "inline-flex";

    prevBtn.style.display =
      currentStep > 1
        ? "inline-flex"
        : "none";
  }

  /* ==========================================================================
     NEXT STEP
     ========================================================================== */

  function nextStep() {
    if (!validateStep()) return;

    if (currentStep === totalQuizScreens) {
      goToLoading();
      return;
    }

    currentStep++;
    showStep(currentStep);
    updateProgress();
    updateButtons();
    updateDogName();
  }

  /* ==========================================================================
     PREV STEP
     ========================================================================== */

  function prevStep() {
    if (currentStep <= 1) return;

    currentStep--;

    showStep(currentStep);
    updateProgress();
    updateButtons();
    updateDogName();
  }

  /* ==========================================================================
     VALIDATION
     ========================================================================== */

  function validateStep() {
    const activeStep = getActiveStep();

    if (!activeStep) return true;

    const dogNameInput = activeStep.querySelector(".zaib_dog_name_input");
    const emailInput = activeStep.querySelector(".zaib_quiz_email_input");

    /*
      Dog name validation.
      This will work even after step numbers are changed.
    */

    if (dogNameInput) {
      if (!dogNameInput.value.trim()) {
        dogNameInput.focus();
        return false;
      }

      zaibQuizData.dog_name = dogNameInput.value.trim();
      updateDogName();
    }

    /*
      Supplements validation.
      This only runs if any remaining rendered screen has data-question="supplements".
      If you removed the supplements screen, this will not affect anything.
    */

    if (activeStep.dataset.question === "supplements") {
      if (!zaibQuizData.supplements || zaibQuizData.supplements.length === 0) {
        alert("Please select at least one option.");
        return false;
      }
    }

    /*
      Email validation.
      This will work on the email screen regardless of the step number.
    */

    if (emailInput) {
      if (!emailInput.value.trim()) {
        emailInput.focus();
        return false;
      }

      zaibQuizData.email = emailInput.value.trim();
    }

    return true;
  }

  /* ==========================================================================
     STEP 6 – DOG BREED AUTOCOMPLETE
     ========================================================================== */

  const breedInput = document.querySelector(".zaib_dog_breed_input");
  const breedSuggestions = document.querySelector(".zaib_breed_suggestions");

  const breedList = [
    "French Bulldog",
    "Labrador Retriever",
    "Golden Retriever",
    "German Shepherd Dog",
    "Poodle",
    "Dachshund",
    "Bulldog",
    "Beagle",
    "Rottweiler",
    "German Shorthaired Pointer"
  ];

  if (breedInput && breedSuggestions) {
    breedInput.addEventListener("input", () => {
      const query = breedInput.value.trim().toLowerCase();

      breedSuggestions.innerHTML = "";

      if (!query) {
        breedSuggestions.style.display = "none";
        return;
      }

      const matches = breedList.filter((breed) =>
        breed.toLowerCase().includes(query)
      );

      if (!matches.length) {
        breedSuggestions.style.display = "none";
        return;
      }

      matches.forEach((breed) => {
        const li = document.createElement("li");
        li.textContent = breed;

        li.addEventListener("click", () => {
          breedInput.value = breed;
          zaibQuizData.dog_breed = breed;
          breedSuggestions.style.display = "none";
        });

        breedSuggestions.appendChild(li);
      });

      breedSuggestions.style.display = "block";
    });

    document.addEventListener("click", (event) => {
      if (
        !breedInput.contains(event.target) &&
        !breedSuggestions.contains(event.target)
      ) {
        breedSuggestions.style.display = "none";
      }
    });
  }

  /* ==========================================================================
     CONTINUE BUTTON
     ========================================================================== */

  if (continueBtn) {
    continueBtn.addEventListener("click", nextStep);
  }

  /* ==========================================================================
     PREV BUTTON
     ========================================================================== */

  if (prevBtn) {
    prevBtn.addEventListener("click", prevStep);
  }

  /* ==========================================================================
     OPTION CLICK
     ========================================================================== */

  document.querySelectorAll(".zaib_quiz_option").forEach((option) => {
    option.addEventListener("click", () => {
      const parentStep = option.closest(".zaib_quiz_step");

      if (!parentStep) return;

      const question = parentStep.dataset.question;
      const value = option.dataset.value;
      const size = option.dataset.size;

      if (!question || !value) return;

      /*
        Multi-select questions.
      */

      if (
        question === "support_areas" ||
        question === "changes" ||
        question === "supplements"
      ) {
        option.classList.toggle("zaib_selected");
        toggleArrayValue(zaibQuizData[question], value);
        return;
      }

      /*
        Single-select questions.
      */

      parentStep.querySelectorAll(".zaib_quiz_option").forEach((item) => {
        item.classList.remove("zaib_selected");
      });

      option.classList.add("zaib_selected");

      zaibQuizData[question] = value;

      if (question === "weight" && size) {
        zaibQuizData.dog_size = size;
      }
    });
  });

  /* ==========================================================================
     BREED BUTTONS
     ========================================================================== */

  document.querySelectorAll(".zaib_quiz_breed_btn").forEach((button) => {
    button.addEventListener("click", function () {
      const value = this.dataset.value;

      if (!value) return;

      zaibQuizData.dog_breed = value;

      if (breedInput) {
        breedInput.value = value;
      }

      if (breedSuggestions) {
        breedSuggestions.style.display = "none";
      }

      document.querySelectorAll(".zaib_quiz_breed_btn").forEach((btn) => {
        btn.classList.remove("zaib_selected");
      });

      this.classList.add("zaib_selected");
    });
  });

  /* ==========================================================================
     QUIZ CLOSE BUTTON
     ========================================================================== */

  const closeBtn = document.querySelector(".zaib_quiz_close_btn");

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      window.location.href = "/";
    });
  }

  /* ==========================================================================
     TOGGLE ARRAY VALUE
     ========================================================================== */

  function toggleArrayValue(array, value) {
    const exists = array.includes(value);

    if (exists) {
      const newArray = array.filter((item) => item !== value);
      array.length = 0;
      newArray.forEach((item) => array.push(item));
    } else {
      array.push(value);
    }
  }

  /* ==========================================================================
     DYNAMIC DOG NAME
     ========================================================================== */

  function updateDogName() {
    const dogName = zaibQuizData.dog_name || "your dog";

    document.querySelectorAll(".zaib_dynamic_dog_name").forEach((item) => {
      item.textContent = dogName;
    });
  }

  /* ==========================================================================
     RESULT PAGE DYNAMIC DATA
     ========================================================================== */

  function updateResultPlanDetails() {
    const selectedSize = zaibQuizData.dog_size || "medium";
    const plan = zaibResultPlanData[selectedSize] || zaibResultPlanData.medium;

    const dailyRoutineEl = document.querySelector(".zaib_result_daily_routine");
    const jarSizeEl = document.querySelector(".zaib_result_jar_size");
    const primaryFocusEl = document.querySelector(".zaib_result_primary_focus");
    const productTitleEl = document.querySelector(".zaib_result_product_title");

    if (dailyRoutineEl) {
      dailyRoutineEl.textContent = plan.chews;
    }

    if (jarSizeEl) {
      jarSizeEl.textContent = plan.jar;
    }

    if (productTitleEl) {
      productTitleEl.textContent = `PetGev Daily Longevity • ${plan.label} Jar`;
    }

    if (primaryFocusEl) {
      if (zaibQuizData.support_areas && zaibQuizData.support_areas.length > 0) {
        primaryFocusEl.textContent = zaibQuizData.support_areas
          .map((item) => item.replace(/-/g, " "))
          .join(" • ");
      } else {
        primaryFocusEl.textContent = "Joints • Gut • Energy";
      }
    }
  }

  /* ==========================================================================
     LOADING SCREEN
     ========================================================================== */

  function goToLoading() {
    currentStep = loadingStep;

    showStep(currentStep);
    updateProgress();
    updateButtons();

    setTimeout(() => {
      goToResult();
    }, 5000);
  }

  /* ==========================================================================
     RESULT SCREEN
     ========================================================================== */

  function goToResult() {
    currentStep = resultStep;

    showStep(currentStep);
    updateProgress();
    updateButtons();
    updateDogName();

    if (
      zaibQuizData.dog_size &&
      window.zaibSubscriptionWidget &&
      typeof window.zaibSubscriptionWidget.updateSize === "function"
    ) {
      window.zaibSubscriptionWidget.updateSize(zaibQuizData.dog_size);
    }

    updateResultPlanDetails();

const resultName = document.querySelector(".zaib_result_name");
const resultAge = document.querySelector(".zaib_result_age");
const resultWeight = document.querySelector(".zaib_result_weight");
const resultBreed = document.querySelector(".zaib_result_breed");
const resultBodyType = document.querySelector(".zaib_result_body_type");
const resultActivity = document.querySelector(".zaib_result_activity");

    if (resultName) {
      resultName.textContent = zaibQuizData.dog_name || "-";
    }

    if (resultAge) {
      resultAge.textContent = zaibQuizData.age || "-";
    }

    if (resultWeight) {
      resultWeight.textContent = zaibQuizData.weight || "-";
    }

    if (resultBreed) {
      resultBreed.textContent = zaibQuizData.dog_breed || "-";
    }

    if (resultBodyType) {
      resultBodyType.textContent = zaibQuizData.body_type || "-";
    }

    if (resultActivity) {
      resultActivity.textContent = zaibQuizData.activity || "-";
    }

    console.log("QUIZ DATA:", zaibQuizData);
  }

  /* ==========================================================================
     RESULT CTA - DIRECT AJAX ADD TO CART
     ========================================================================== */

  document.body.addEventListener(
    "click",
    function (event) {
      const cta = event.target.closest(".zaib_result_cta");

      if (!cta) return;

      event.preventDefault();
      event.stopPropagation();

      const selectedSize = zaibQuizData.dog_size || "mini";
      const selectedPlan = zaibPlanData[selectedSize] || zaibPlanData.mini;

      const variantId =
        cta.dataset.variantId ||
        document.querySelector('input[name="id"]')?.value ||
        document.querySelector('select[name="id"]')?.value;

      if (!variantId) {
        alert("Variant ID missing. Please add data-variant-id on the CTA button.");
        console.warn("ZAIB: Variant ID missing.");
        return;
      }

      cta.disabled = true;
      cta.classList.add("zaib_loading");
      cta.textContent = "ADDING...";

      const formData = new FormData();

      formData.append("id", variantId);
      formData.append("quantity", "1");
      formData.append("selling_plan", selectedPlan.plan);

      formData.append("properties[Dog Size]", selectedPlan.dog);
      formData.append("properties[Dog Weight]", selectedPlan.weight);
      formData.append("properties[Chews Per Day]", selectedPlan.chews);

      // if (zaibQuizData.dog_name) {
      //   formData.append("properties[Dog Name]", zaibQuizData.dog_name);
      // }

      // if (zaibQuizData.age) {
      //   formData.append("properties[Dog Age]", zaibQuizData.age);
      // }

      // if (zaibQuizData.dog_breed) {
      //   formData.append("properties[Dog Breed]", zaibQuizData.dog_breed);
      // }

      fetch("/cart/add.js", {
        method: "POST",
        body: formData
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Cart add failed");
          }

          return response.json();
        })
        .then((data) => {
          console.log("ZAIB ADDED TO CART:", data);
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("ZAIB CART ERROR:", error);

          alert(
            "Something went wrong while adding to cart. Please check variant ID and selling plan ID."
          );

          cta.disabled = false;
          cta.classList.remove("zaib_loading");

          cta.innerHTML = `START <span class="zaib_dynamic_dog_name">${
            zaibQuizData.dog_name || "YOUR DOG"
          }</span>'S PLAN`;
        });
    },
    true
  );
});